<template>
  <div class="partnet-point-index">
    <p v-if="fetching">
      <Loading />
    </p>
    <template v-else>

      <Tabs  />

      <div class="s-p-3">
        <div class="s-bg-white rounded rounded-2 d-flex partnet-point-index__point">
          <div class="text-center w-50">
            <div class="mb-2">5,250</div>
            <div class="s-text-xs">我的點數</div>
          </div>
          <div class="text-center w-50">
            <div class="s-text-secondary mb-2">1,250</div>
            <div class="s-text-xs">2025/12/31即將到期</div>
          </div>
        </div>
      </div>

      <div class="s-p-3">

        <div>
          <label class="field__label">
            請輸入序號兌換寶雅點數
          </label>
          <div class="d-flex">
            <input class="field__input flex-fill mr-2" placeholder="輸入優惠券代碼" />
            <button class="s-btn s-btn-primary s-btn-sm w-auto text-nowrap px-4"
              @click="[redeem, redeemFail][Math.random() > 0.5 ? 0 : 1]()">確認</button>
          </div>
        </div>

        <div class="partnet-point-index__list">
          <div class="divider">可兌換</div>
          <Item v-for="(i, idx) in availables" :key="idx" :item="i"></Item>
        </div>


        <div class="partnet-point-index__list">
          <div class="partnet-point-index__list__divider">無法兌換</div>
          <Item v-for="(i, idx) in availables" :key="idx" :item="i"></Item>
        </div>


      </div>

    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Loading from '@/components/Page/Liff/Shared/Loading'
import list from '@/mixins/liff/memberCard/list'
import Item from '@/components/Page/Liff/MemberCard/PartnetPoint/Item.vue';
import Tabs from '@/components/Page/Liff/MemberCard/PartnetPoint/Tabs.vue';

export default {
  mixins: [list],
  components: { Loading, Item,Tabs },
  data: () => ({    
    availables: [{
      title: '亞洲萬里通',
      exchange: [{
        from: { value: 1000, unit: '點' },
        to: { value: 100, unit: '哩程' },
      }],
      partner_org_hashid: '123',
      image: 'image-0.png',
    }, {
      title: 'ANA 哩程俱樂部',
      exchange: [{
        from: { value: 750, unit: '點' },
        to: { value: 100, unit: '哩程' },
      }],
      partner_org_hashid: '456',
      image: 'image-1.png',
    }, {
      title: 'Hami Point',
      exchange: [{
        from: { value: 50, unit: '點' },
        to: { value: 50, unit: '點' },
      }, {
        from: { value: 200, unit: '點' },
        to: { value: 220, unit: '點' },
      }],
      partner_org_hashid: '789',
      image: 'image-2.png',
      more: true,
    }]
  }),
  methods: {
    ...mapActions({
      getTransactions: 'liffMemberCard/getTransactions',
    }),
    async fetch() {

    },
    redeem() {
      this.$swal({
        title: "POYA 點數 100 點兌換成功！",
        type: "success",
        showConfirmButton: false
      });
    },
    redeemFail() {
      this.$swal({
        title: "兌換失敗！",
        text: "執行寶雅序號兌換寶雅點數，操作失敗",
        type: "error",
        showConfirmButton: false
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.partnet-point-index {
  margin: -1rem -0.75rem 0;

  &__point {
    font-weight: 500;
    font-size: 32px;
    color: black;
    line-height: 100%;
    padding: 1rem 0;

    > :first-child {
      border-right: 3px solid #E3E3E3;
    }
  }

  &__list {
    margin-top: 1rem;
    line-height: 150%;

    
  }
}


.s-text-secondary {
  color: #FE577F !important;
}


.field {
  &:not(:last-of-type) {
    margin-bottom: 24px;
  }

  &__label {
    font-weight: 400;
    font-size: 14px;
    color: var(--liff-primary_text_color);
    margin-bottom: 8px;
    display: block;
  }

  &__desc {
    color: var(--liff-secondary_text_color);
    font-size: 12px;
    line-height: 1;
    margin-top: 4px;
  }

  &__input {
    font-weight: 500;
    font-size: 16px;
    color: var(--liff-primary_text_color);
    border: none;
    border-bottom: 1px solid #e5e5ea;
    background: white;
    padding-bottom: 8px;
    width: 100%;
    border: 1px solid #999999;
    border-radius: 5px;
    padding: 8px 12px;

    &::placeholder {
      color: #b7b7b7;
    }

    &:focus {
      border: 1px solid #E3E3E3;
    }

    &.invalid {
      border-bottom: 1px solid #fe0000;
    }

    &:read-only {
      background-color: #f0f0f0;
    }
  }
}
</style>
